
<cx-generic-link *ngIf="data$ | async as data" [url]="data.url" [style]="data.styleAttributes" [target]="getTarget(data)" >
  <ng-container *ngIf="!data.media">{{ data.linkName }}</ng-container> 
  <cx-media *ngIf="data.media && data.media.url" [container]="data.media"></cx-media>
</cx-generic-link>
